<verify-email-change-page>
  <div if="{locale}" class="container">
    <div class="verification-card">
      <div class="brand-header">
        <img src="./Lark.png" alt="MetaLark.ai" class="brand-logo" />
        <h1 class="brand-title">{locale?.t('verifyemailchange_title')}</h1>
        <p class="brand-tagline font-medium">{locale?.t('verifyemailchange_tagline')}</p>
      </div>

      <div if={state.loading} class="loading-state mt-4">
        <div class="spinner"></div>
        <h2>{locale?.t('verifyemailchange_verifying_title')}</h2>
        <p class="font-medium">{locale?.t('verifyemailchange_verifying_message')}</p>
      </div>

      <div if={state.success && !state.changeCompleted} class="partial-success-state">

        <div class="success-icon">✓</div>
        <h2 class="font-medium" if={state.isOldEmail}>{locale?.t('verifyemailchange_oldemail_verified')}</h2>
        <h2 class="font-medium" if={state.isNewEmail}>{locale?.t('verifyemailchange_newemail_verified')}</h2>
        <p class="verification-status">
          <span class="font-medium {state.oldEmailVerified ? 'status-verified' : 'status-pending'}">
            {state.oldEmailVerified ? '✓' : '○'} {locale?.t('verifyemailchange_status_oldverified')}
          </span>
          <br/>
          <span class="font-medium {state.newEmailVerified ? 'status-verified' : 'status-pending'}">
            {state.newEmailVerified ? '✓' : '○'} {locale?.t('verifyemailchange_status_newverified')}
          </span>
        </p>
        <p class="next-step font-medium">{locale?.t('verifyemailchange_nextstep')}</p>
        <a href="#/settings" class="btn btn-primary">{locale?.t('verifyemailchange_backtosettings')}</a>
      </div>

      <div if={state.changeCompleted} class="success-state">

        <div class="success-icon">✓</div>
        <h2>{locale?.t('verifyemailchange_success_title')}</h2>
        <p>{locale?.t('verifyemailchange_success_message')}</p>
        <p class="email-change-info">
          <strong>{locale?.t('verifyemailchange_newemail')}</strong> {state.newEmail}
        </p>
        <p class="next-step">{locale?.t('verifyemailchange_success_nextstep')}</p>
        <div class="success-actions">
          <a href="#/settings" class="btn btn-primary">{locale?.t('verifyemailchange_gotosettings')}</a>
          <a href="#/login" class="btn btn-secondary">{locale?.t('verifyemailchange_gotologin')}</a>
        </div>
      </div>

      <div if={state.error} class="error-state">

        <div class="error-icon">✗</div>
        <h2>{locale?.t('verifyemailchange_failed_title')}</h2>
        <p class="error-message">{state.message}</p>
        <div class="error-actions">
          <a href="#/settings" class="btn btn-primary">{locale?.t('verifyemailchange_backtosettings')}</a>
          <a href="#/login" class="btn btn-secondary">{locale?.t('verifyemailchange_returntologin')}</a>
        </div>
      </div>
    </div>
  </div>

  <style>
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
      padding: 20px;
      border-radius: 20px;
    }

    .verification-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      padding: 40px;
      max-width: 500px;
      width: 100%;
      text-align: center;
    }

    .brand-header {
      /*margin-bottom: 32px;*/
      padding-bottom: 24px;
      border-bottom: 1px solid #e5e7eb;
    }

    .brand-logo {
      height: 48px;
      width: auto;
      margin: 0 auto 16px;
      display: block;
    }

    .brand-title {
      color: var(--color-accent);
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    .brand-tagline {
      color: #6b7280;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
      letter-spacing: 0.5px;
    }

    .loading-state,
    .success-state,
    .partial-success-state,
    .error-state {
      animation: fadeIn 0.3s ease-in;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .spinner {
        border: 4px solid #f3f3f3;
        border-top: 4px solid var(--color-primary);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
        margin: 0 auto 20px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .success-icon,
    .error-icon {
      font-size: 64px;
      margin-bottom: 20px;
    }

    .success-icon {
      color: #10b981;
    }

    .error-icon {
      color: #ef4444;
    }

    h2 {
      color: var(--color-accent);
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 600;
    }

    p {
      color: #6b7280;
      line-height: 1.6;
      margin-bottom: 12px;
    }

    .next-step {
      color: #4b5563;
      font-weight: 500;
      margin-top: 20px;
      margin-bottom: 24px;
    }

    .error-message {
      color: #dc2626;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .verification-status {
      background: #f3f4f6;
      padding: 20px;
      border-radius: 8px;
      margin: 20px 0;
      text-align: left;
      font-size: 16px;
      line-height: 2;
    }

    .status-verified {
      color: #047857;
      font-weight: 600;
    }

    .status-pending {
      color: #4b5563;
    }

    .email-change-info {
      background: #eff6ff;
      padding: 16px;
      border-radius: 8px;
      border-left: 4px solid var(--color-accent);
      margin: 20px 0;
      text-align: left;
    }

    .btn {
      /*padding: 12px 24px;*/
      /*border-radius: 8px;*/
      /*font-weight: 500;*/
      /*cursor: pointer;*/
      /*transition: all 0.2s;*/
      /*border: none;*/
      /*font-size: 16px;*/
      /*text-decoration: none;*/
      /*display: inline-block;*/
      /*margin: 6px;*/
    }

    .btn-primary:hover:not(:disabled) {
        background: var(--color-primary);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .btn-primary:disabled {
        background: #9ca3af;
        cursor: not-allowed;
    }

    .btn-secondary {
        background: #ffffff;
        color: var(--color-primary);
        border: 1px solid var(--color-primary);
        margin-right: 12px;
        box-shadow: none;
    }

    .btn-secondary:hover {
        background: #ffffff;
        color: var(--color-primary);
        border: 1px solid var(--color-primary);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    .success-actions,
    .error-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 24px;
    }

    @media (min-width: 640px) {
      .success-actions,
      .error-actions {
        flex-direction: row;
        justify-content: center;
      }
    }
  </style>

  <script>
    import { getApi } from '../services/service-loader'

    export default {
      includeTools: false,

      state: {
        loading: true,
        success: false,
        error: false,
        message: '',
        isOldEmail: false,
        isNewEmail: false,
        oldEmailVerified: false,
        newEmailVerified: false,
        changeCompleted: false,
        newEmail: ''
      },

      async onMounted() {
        // Get token from query params
        const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
        const token = urlParams.get('token')

        if (!token) {
          this.update({
            loading: false,
            error: true,
            message: this.locale.t('verifyemailchange_error_notoken')
          })
          return
        }

        // Verify the email change token
        await this.verifyEmailChange(token)
      },

      async verifyEmailChange(token) {
        try {
          const api = await getApi()
          const response = await api.post('/email/change/verify', { token })

          if (response.data.verified) {
            if (response.data.changeCompleted) {
              // Both emails verified, change is complete
              this.update({
                loading: false,
                success: true,
                changeCompleted: true,
                error: false,
                newEmail: response.data.newEmail || '',
                message: this.locale.t('verifyemailchange_success_complete')
              })
            } else {
              // One email verified, waiting for the other
              this.update({
                loading: false,
                success: true,
                changeCompleted: false,
                error: false,
                isOldEmail: response.data.isOldEmail,
                isNewEmail: response.data.isNewEmail,
                oldEmailVerified: response.data.isOldEmail || response.data.bothVerified,
                newEmailVerified: response.data.isNewEmail || response.data.bothVerified,
                message: response.data.message
              })
            }
          } else {
            this.update({
              loading: false,
              success: false,
              error: true,
              message: response.data.message || this.locale.t('verifyemailchange_error_verification')
            })
          }
        } catch (error) {
          console.error('Email change verification error:', error)
          this.update({
            loading: false,
            success: false,
            error: true,
            message: error.response?.data?.message || this.locale.t('verifyemailchange_error_generic')
          })
        }
      }
    }
  </script>
</verify-email-change-page>